import React, { useEffect, useState } from "react";
import "./ExpensesSettings.scss";
import { useGlobalSettings } from "../../../context/GlobalSettingsContext";
import {
  getAllGlobalSettingsData,
  updateExpenseSettings,
} from "../../../services/api/GlobalSettingsApi";
import { useToast } from "../../../context/ToastContext";
import { useNavigate } from "react-router-dom";
import JusticeLoader from "../../../components/JusticeLoader/JusticeLoader";

const ExpenseSettings = () => {
  const navigate = useNavigate();
  const [fetchingData, setFetchingData] = useState(true);
  const { globalSettings, setGlobalSettings } = useGlobalSettings();

  const [settings, setSettings] = useState({
    currency: "INR",
    notifyAdmin: false,
    expenseTypes: [],
    resourceTypes: [],
    resourceName: [],
  });

  const [loading, setLoading] = useState(false);
  const [newExpenseType, setNewExpenseType] = useState("");
  const [newResourceName, setNewResourceName] = useState("");
  const [newResourceType, setNewResourceType] = useState("");
  const { showToast } = useToast();

 

  useEffect(() => {
    const fetchExpenseSettings = async () => {
      try {
        setFetchingData(true);
        const response = await getAllGlobalSettingsData();

        if (response?.data?.result?.[0]?.expenseSettings) {
          const expenseSettings = response.data.result[0].expenseSettings;
          setSettings({
            currency: "INR",
            notifyAdmin: false,
            expenseTypes: [],
            resourceTypes: [],
            resourceName: [],
            ...expenseSettings,
          });

          // Update global settings if not already set
          if (!globalSettings) {
            setGlobalSettings(response.data);
          }
        } else {
          // Set default values if no data exists
          setSettings({
            currency: "INR",
            notifyAdmin: false,
            expenseTypes: [],
            resourceTypes: [],
            resourceName: [],
          });
        }
      } catch (error) {
        console.error("Error fetching expense settings:", error);
        showToast("Failed to fetch expense settings", "error");
        // Set defaults on error
        setSettings({
          currency: "INR",
          notifyAdmin: false,
          expenseTypes: [],
          resourceTypes: [],
          resourceName: [],
        });
      } finally {
        setFetchingData(false);
      }
    };

    fetchExpenseSettings();
  }, [globalSettings, setGlobalSettings]);

  useEffect(() => {
    const freshInitial = {
      currency: "INR",
      notifyAdmin: false,
      expenseTypes: [],
      resourceTypes: [],
      resourceName: [],
      ...(globalSettings?.result?.[0]?.expenseSettings || {}),
    };
    setSettings(freshInitial);
  }, [globalSettings]);

  if (fetchingData) {
  return (
    <section className="exp-sett-section">
      <h3 className="exp-sett-title">Expense Settings</h3>
      <JusticeLoader message="Loading expense settings..." type="gavel" />
    </section>
  );
}

  const handleChange = (field, value) => {
    setSettings((prev) => ({ ...prev, [field]: value }));
  };

  const handleToggle = (field) => {
    setSettings((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const addToList = (field, value) => {
    if (value.trim() && !settings[field]?.includes(value.trim())) {
      setSettings((prev) => ({
        ...prev,
        [field]: [...(prev[field] || []), value.trim()],
      }));
    }
  };

  const removeFromList = (field, index) => {
    const item = settings[field][index];
    if (
      (field === "expenseTypes" && item === "Other") ||
      (field === "resourceTypes" && item === "Other")
    )
      return; // Prevent removing 'Other' from specific fields

    setSettings((prev) => ({
      ...prev,
      [field]: prev[field].filter((_, i) => i !== index),
    }));
  };

  const handleSave = async () => {
    const payload = {
      currency: settings.currency?.trim() || "INR",
      notifyAdmin: settings.notifyAdmin || false,
      expenseTypes: settings.expenseTypes || [],
      resourceTypes: settings.resourceTypes || [],
      resourceName: settings.resourceName || [],
    };

    setLoading(true);
    console.log(payload, "checkkk");
    try {
      await updateExpenseSettings(payload);
      const updated = await getAllGlobalSettingsData();

      setGlobalSettings(updated.data);
      localStorage.setItem("globalSettings", JSON.stringify(updated.data));

      showToast("Expenses updated successfully.", "success");
      setTimeout(() => {
        navigate("/home/displayboard");
      }, 300);
    } catch (err) {
      console.error(err);
      showToast("Something went wrong to update Expenses!", "error");
    } finally {
      setLoading(false);
    }
  };

  const renderListEditor = (title, field, value, setValue, placeholder) => (
    <div className="settings-card">
      <h4 className="card-title">{title}</h4>
      <div className="list-editor-container">
        <div className="list-input-row">
          <input
            type="text"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                addToList(field, value);
                setValue("");
              }
            }}
            placeholder={placeholder}
          />
          <button
            type="button"
            onClick={() => {
              addToList(field, value);
              setValue("");
            }}
            className="add-item-btn"
          >
            Add
          </button>
        </div>
        <div className="items-list">
          {settings[field]?.map((item, i) => (
            <div key={i} className="list-item">
              <span className="item-name">{item}</span>
              {/* Hide remove button for 'Other' in expenseTypes and resourceTypes */}
              {!(
                (field === "expenseTypes" && item === "Other") ||
                (field === "resourceTypes" && item === "Other")
              ) && (
                <button
                  type="button"
                  onClick={() => removeFromList(field, i)}
                  className="remove-item-btn"
                >
                  ×
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <>
      <section className="exp-sett-section">
        <h3 className="exp-sett-title">Expense Settings</h3>

        <div className="settings-container">
          <div className="settings-card">
            <h4 className="card-title">General Settings</h4>
            
            <div className="form-group-exp-settings">
              <label>Currency</label>
              <select
                value={settings.currency || "INR"}
                onChange={(e) => handleChange("currency", e.target.value)}
              >
                <option value="INR">INR</option>
                <option value="USD">USD</option>
                <option value="EUR">EUR</option>
              </select>
            </div>

            <div className="toggle-row">
              <label>Notify Admin</label>
              <div className="toggle-switch">
                <input
                  type="checkbox"
                  checked={settings.notifyAdmin || false}
                  onChange={() => handleToggle("notifyAdmin")}
                  id="notifyAdmin"
                />
                <label htmlFor="notifyAdmin" className="toggle-slider"></label>
              </div>
            </div>
          </div>

          {renderListEditor(
            "Expense Types",
            "expenseTypes",
            newExpenseType,
            setNewExpenseType,
            "Add new expense type"
          )}

          {renderListEditor(
            "Resource Names",
            "resourceName",
            newResourceName,
            setNewResourceName,
            "Add new resource name"
          )}

          {renderListEditor(
            "Resource Types",
            "resourceTypes",
            newResourceType,
            setNewResourceType,
            "Add new resource type"
          )}
        </div>

        <div className="action-buttons">
          <button
            className="cancel-btn"
            onClick={() => navigate("/home/displayboard")}
          >
            Cancel
          </button>
          <button
            className="save-btn"
            onClick={handleSave}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Expense Settings"}
          </button>
        </div>
      </section>
    </>
  );
};

export default ExpenseSettings;